const Dashboard = () => import('@/modules/dashboard/views/Index')

const routes = [{
  name: 'dashboard',
  component: Dashboard,
  path: 'dashboard',
  meta: {
    requiresAuth: true,
    title: 'Dashboard',
    breadcrumb: null
  }
}]

export default routes
